/**
 * Module header (P7): ACO selector + context line, shared by all APP Plus pages.
 */
import { Calendar, Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { YearLockBanner } from '@/components/gap-management/shared/YearLockBanner';

export function AcoHeader({ title, subtitle, showReportBar = false }: {
  title: string;
  subtitle?: string;
  /** Report-style pages only (QPS Management): "Report Date" + Print PDF.
      Configuration/settings pages do NOT get it (owner 2026-07-14 PM). */
  showReportBar?: boolean;
}) {
  // The top-bar chips carry the ACO name + track + year (D7); the page header
  // does NOT duplicate them.
  const reportDate = new Date().toLocaleDateString('en-US', {
    month: '2-digit', day: '2-digit', year: 'numeric',
  });

  return (
    <div className="mb-6">
      <YearLockBanner />
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold">{title}</h1>
          {subtitle && <p className="text-muted-foreground">{subtitle}</p>}
        </div>
      </div>
      {showReportBar && (
        <div className="mt-1 flex flex-wrap items-center justify-between gap-2">
          <p className="flex items-center gap-1.5 text-sm text-muted-foreground">
            <Calendar className="h-4 w-4" />
            Report Date: <span className="font-medium text-foreground">{reportDate}</span>
          </p>
          <Button variant="ghost" size="sm" className="text-muted-foreground quality-print-hide"
            onClick={() => window.print()}>
            <Printer className="mr-1.5 h-4 w-4" /> Print PDF
          </Button>
        </div>
      )}
    </div>
  );
}

export function NoAcoState() {
  return (
    <div className="mx-auto max-w-lg py-16 text-center">
      <h2 className="text-xl font-semibold">No ACO selected</h2>
      <p className="mt-2 text-muted-foreground">
        Register or open an ACO from the Home page (Your ACOs) to start APP Plus reporting.
      </p>
    </div>
  );
}

export function YearUnsupportedState({ year }: { year: number }) {
  return (
    <div className="mx-auto max-w-lg py-16 text-center">
      <h2 className="text-xl font-semibold">APP Plus does not apply to {year}</h2>
      <p className="mt-2 text-muted-foreground">
        The APP Plus quality measure set begins with performance year 2026. Switch the viewing
        year in the top bar.
      </p>
    </div>
  );
}
